<template>
  <dm-select
    ref="dmSelect"
    :value="selectedItem"
    :class="['normal-select', 'size-' + size, disabled ? 'disabled' : '']"
    :style="{ width: width }"
    @input="selectChange"
    :placeholder="placeholder"
    :filterable="filterable"
    clearable
    :size="size"
    :multiple="multiple"
    :disabled="disabled"
    v-bind="$attrs"
    @visible-change="changeState"
  >
    <!--单选-->
    <template v-slot:tag="item">
      <el-tag class="single-tag" size="small" type="info" disable-transitions>
        {{ item.option.currentLabel }}
      </el-tag>
    </template>
    <!--多选-->
    <template v-slot:tagOut="item">
      <el-tag
        class="multiple-tag"
        :closable="!disabled"
        size="small"
        type="info"
        @close="$refs.dmSelect.deleteTag($event, item.option)"
        disable-transitions
      >
        {{ item.option.currentLabel }}
      </el-tag>
    </template>
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :disabled="item.disabled"
      class="select-list-item"
    ></el-option>
  </dm-select>
</template>

<script>
import DmSelect from "@/components/BaseComponents/DmSelect"
export default {
  name: "normal-select",
  components: { DmSelect },
  props: {
    width: String,
    selectList: Array,
    selectedItem: [Number, String, Array],
    defaultLabel: {
      type: String,
      default: "选项不存在"
    },
    multiple: Boolean,
    disabled: Boolean,
    size: {
      type: String,
      default: "small" // small, normal
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    filterable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    options() {
      let options = this.selectList || []
      let existValues = options.map(o => o.value)
      if (this.multiple) {
        return options.concat(
          (this.selectedItem || [])
            .filter(value => !existValues.includes(value))
            .map(value => ({
              label: this.defaultLabel,
              value: value,
              disabled: true
            }))
        )
      } else {
        if (!this.selectedItem || existValues.includes(this.selectedItem)) return options
        return options.concat({
          label: this.defaultLabel,
          value: this.selectedItem,
          disabled: true
        })
      }
    }
  },
  methods: {
    selectChange(value) {
      // 该组件若绑定 handle-select 事件，则将 item 传递给父组件
      if (Object.prototype.hasOwnProperty.call(this.$listeners, "handle-select")) {
        this.$emit(
          "handle-select",
          this.selectList.find(i => i.value === value)
        )
      }
      this.$emit("update:selectedItem", value)
    },
    changeState(val) {
      this.$emit("changeState", val)
    }
  }
}
</script>

<style lang="scss" scoped>
.normal-select {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  &.size-small {
    min-height: 32px;
    line-height: 32px;
    .single-tag {
      line-height: 18px;
    }
    ::v-deep {
      .el-input__inner {
        line-height: 32px;
        min-height: 32px;
      }
    }
  }
  &.size-normal {
    min-height: 40px;
    line-height: 40px;
    ::v-deep {
      .el-input__inner {
        line-height: 40px;
        min-height: 40px;
      }
    }
  }
  &.disabled {
    .single-tag {
      background: #f6f7fa;
    }
  }
  .single-tag {
    color: #606266;
    background: #fff;
    border: none;
    font-size: 14px;
    white-space: normal;
    word-break: break-all;
  }
  .multiple-tag {
    white-space: normal;
    word-break: break-all;
    min-height: 24px;
    height: unset;
    margin: 2px 0 2px 6px;
    ::v-deep {
      .el-tag__close {
        background-color: #c0c4cc;
      }
    }
  }
  &:hover {
    ::v-deep .el-input .el-input__inner {
      border-color: #2196f3;
    }
  }
  ::v-deep {
    .el-input {
      .el-input__inner {
        border: 1px solid #dcdfe6;
      }
    }
    .el-select-dropdown__item.hover {
      background-color: transparent;
    }
    .select-list-item:hover {
      &.selected {
        color: #409eff;
      }
      color: #fff;
      background-color: #1e88e5;
    }
  }
}
</style>
